import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCollaborationSidebarState } from '../hooks';
import useCollaborationSidebarProps from '../hooks/useCollaborationSidebarProps'; // @ts-expect-error no-type

import AsyncCollaborationSidebarContainerWithSidebarSkeleton from 'collaboration-sidebar/features/fixedSidebar/components/AsyncCollaborationSidebarContainerWithSidebarSkeleton'; // @ts-expect-error no-type

import AsyncCollaborationSidebarContainerWithoutSidebarSkeleton from './sidebar/CollaborationSidebar/AsyncCollaborationSidebarContainerWithoutSidebarSkeleton';
import LayoutWithRightSidebar from './LayoutWithRightSidebar';
// TODO break this component down into CollaborationSidebar and CollaborationSidebarDragArea
// https://git.hubteam.com/HubSpot/MarketingOrchestration/issues/3212
export default function LayoutWithCollaborationSidebarInner({
  children
}) {
  const collaborationSidebarProps = useCollaborationSidebarProps();
  const {
    floating,
    isListingPage,
    hasSidebarPermission,
    noLayout,
    isControlled,
    pageContentRef,
    commentingDisabled
  } = collaborationSidebarProps;
  const {
    objectId,
    objectType,
    collaborationSidebarState
  } = useCollaborationSidebarState();

  if (!hasSidebarPermission) {
    if (children) {
      return children;
    }

    return null;
  }

  const sidebar = (objectId || isListingPage || commentingDisabled) && objectType && (floating ? /*#__PURE__*/_jsx(AsyncCollaborationSidebarContainerWithoutSidebarSkeleton, Object.assign({}, collaborationSidebarProps, {
    collaborationSidebarState: collaborationSidebarState
  })) : /*#__PURE__*/_jsx(AsyncCollaborationSidebarContainerWithSidebarSkeleton, Object.assign({}, collaborationSidebarProps, {
    collaborationSidebarState: collaborationSidebarState
  })));
  return noLayout ? /*#__PURE__*/_jsx(_Fragment, {
    children: sidebar
  }) : /*#__PURE__*/_jsx(LayoutWithRightSidebar, {
    sidebar: sidebar,
    isControlled: isControlled,
    ref: pageContentRef,
    children: children
  });
}